<!--
 * @Author: jackshen
 * @Date: 2021-03-26 10:50:28
 * @LastEditors: wenlin
 * @LastEditTime: 2021-03-26 17:21:40
 * @Description:
-->
<template>
  <div>
    <common-banner :imgSrc="imgPath" :imgLabel="imgLabel" :path="'/paper'" :imgType='"scroll"'></common-banner>
    <home-main>
      <template slot="slot">
        <el-col :span="7">
          <el-breadcrumb
            separator-class="el-icon-arrow-right"
            style="marginTop: 20px; marginBottom: 20px;"
          >
            <el-breadcrumb-item :to="{ path: '/paper' }"><i class="el-icon-s-home"></i> 文献库</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/paper' }"
              ><i class="el-icon-coin"></i> 条件搜索</el-breadcrumb-item
            >
          </el-breadcrumb>
          <!-- 左边手风琴筛选列表 -->
          <el-collapse v-model="activeNames" @change="handleChange">
            <el-collapse-item
              v-show="obj.show"
              :title="k == 'year' ? '时间' : k == 'language' ? '语言' : k =='journal' ? '期刊' : k == 'subject' ? '主题': '作者'"
              :name="k"
              v-for="(obj, k, i) in dataObj"
              :key="i"
            >
              <div class="year_content">
                <div
                  v-for="(item, index) in obj.val"
                  :key="index"
                  class="left_item"
                  :class="{ active_left_item: item['item'] == tagList[i] }"
                  @click="pushTag(item, i)"
                >
                  <span style="width: 70%">{{
                    item.label
                  }}</span>
                  <span v-show="k!=='author'" style="width: 15%">{{ "(" + item.count + ")" }}</span>
                </div>
              </div>
              <!-- <el-input
                v-show="obj.filter"
                placeholder="请输入内容"
                size="mini"
                v-model="queryObj[k]"
                style="width: 170px; marginLeft: 10px;"
              ></el-input>
              <el-button
                v-show="obj.filter"
                type="info"
                size="mini"
                @click="showTag(queryObj[k], i)"
                style="marginLeft: 10px;"
                >确认</el-button
              >
              <el-button
                type="info"
                size="mini"
                @click="resetTag(k, i)"
                :style="`marginLeft: ${k==='year'?'10px':'264px'};`"
                >重置</el-button
              > -->
            </el-collapse-item>
          </el-collapse>
          <el-button type="success" @click="downloadEndnote" style="background-color: #006f6f; border-color: #006f6f;width: 80%; margin-left: 10%; margin-top: 35px; margin-bottom: 20px; height: 50px; font-size: 16px; font-weight: 600;">文献导出（Endnote格式）</el-button>
          <p style="margin-left: 10%; margin-top: -15px; color: #8c939d; font-size: 12px;">* 根据筛选条件导出当前分页文献数据</p>
        </el-col>
        <!-- 文献列表 -->
        <el-col :span="17" style="margin: 0 40px">
          <template>
            <div class="instance_search">
              <instance-search @search="onSearch"></instance-search>
            </div>
            <el-tag
              :key="t"
              v-for="(tag, t) in tagList"
              closable
              :disable-transitions="false"
              @close="handleClose(tag, t)"
              v-show="tag"
              style="margin: 5px;"
            >
              {{ getTagDesc(tag, t) }}
            </el-tag>
            <!-- <transition name="el-fade-in-linear"> -->
              <div v-loading="listShow" v-if="instanceList.length>0">
                <el-card
                  v-for="(item, index) in instanceList"
                  :key="index"
                  class="instance_item"
                  style="marginBottom: 20px"
                >
                  <div @click="toDetail(item)">
                  <text-highlight
                    :queries="[
                      queryObj['title'],
                      queryObj['year'],
                      queryObj['journal'],
                      queryObj['author'],
                    ]"
                    class="instance_item_title"

                    >{{ item.title }}</text-highlight
                  >
                  </div>
                  <!-- <p class="instance_item_summary">{{item.summary}}</p> -->
                  <text-highlight
                    :queries="[
                      queryObj['title'],
                      queryObj['year'],
                      queryObj['journal'],
                      queryObj['author'],
                    ]"
                    class="instance_item_summary"
                    style="-webkit-box-orient: vertical;"
                  >摘要：{{ item.summary }}</text-highlight
                  >
                  <p class="instance_item_info">
                    <text-highlight
                      :queries="[
                        queryObj['title'],
                        queryObj['year'],
                        queryObj['journal'],
                        queryObj['journal'],
                      ]"
                      >作者：{{ item.author }}</text-highlight
                    >
                    <text-highlight
                      :queries="[
                        queryObj['title'],
                        queryObj['year'],
                        queryObj['journal'],
                        queryObj['author'],
                      ]"
                      style="margin-left: 20px;"
                      >期刊/论文集：{{ item.journal }}</text-highlight
                    >
                    <!--text-highlight
                      :queries="[
                        queryObj['title'],
                        queryObj['year'],
                        queryObj['instance'],
                        queryObj['author'],
                      ]"
                      style="margin-left: 20px;"
                      >机构：{{ item.institution }}</text-highlight
                    -->
                    <text-highlight
                      :queries="[
                        queryObj['title'],
                        queryObj['year'],
                        queryObj['journal'],
                        queryObj['author'],
                      ]"
                      style="margin-left: 20px;"
                      >时间：{{ item.year + "年" }}</text-highlight
                    >
                  </p>
                  <!-- <p>{{'关键词：'+item.keywords}}</p> -->
                  <p v-if="item.language==='cn'">
                    <span>{{ "页数：" + item.page }}</span
                    ><span style="marginLeft: 20px">{{
                      "ISBN：" + item.isbnIssn
                    }}</span>
                    <span style="marginLeft: 20px">{{
                      "数据库：" + item.databaseProvided
                    }}</span>
                  </p>
                  <!--el-button
                    type="text"
                    style="marginLeft: 80%"
                    @click="toDetail(item)"
                    >查看详情</el-button
                  -->
                  <el-divider style="margin:0"></el-divider>
                </el-card>
              </div>
              <div v-else><h4 style="textAlign:center">暂无数据~</h4></div>
            <!-- </transition> -->
          </template>
<el-pagination v-show="total>0" class="pagination" background layout="total, sizes, prev, pager, next" :total="total" :current-page.sync="queryList['page']" :page-size="queryList['pageSize']" :page-sizes="[10,20,50,100]" @current-change="handleCurrentChange"
    @size-change="handleSizeChange" />
</el-col>
</template>
</home-main>
</div>
</template>

<script>
// import axios from 'axios'
import CommonBanner from '@/pages/common/Banner'
import HomeMain from '@/pages/homepage/components/Main'
import Dropper from '@/pages/common/Dropper'
import Carder from '@/pages/common/Carder'
import InstanceSearch from '@/pages/common/InstanceSearch'
import {
  getInstanceYears,
  getInstanceList,
  getInstance,
  getLanguage,
  getAuthor,
  getSubject,
  points
} from '@/api/instance'
import TextHighlight from 'vue-text-highlight'
import axios from 'axios'
export default {
  name: 'TestPage',
  components: {
    HomeMain,
    CommonBanner,
    Dropper,
    Carder,
    TextHighlight,
    InstanceSearch
  },
  data () {
    return {
      imgPath: require('@/assets/images/banner/papers_banner.jpg'),
      imgLabel: '开放数林',
      yearList: [],
      activeNames: ['year', 'language', 'subject', 'journal', 'author'],
      queryObj: {
        year: '',
        language: '',
        subject: '',
        journal: '',
        author: '',
        title: ''
      },
      instanceList: [],
      authorList: [],
      dataObj: {
        year: {
          show: true,
          filter: true,
          val: []
        },
        language: {
          show: true,
          filter: false,
          val: []
        },
        subject: {
          show: true,
          filter: false,
          val: []
        },
        journal: {
          show: false,
          filter: true,
          val: []
        },
        author: {
          show: false,
          filter: true,
          val: []
        }
      },
      queryList: {
        page: 1,
        pageSize: 10
      },
      total: 0,
      tagList: ['', '', '', '', ''],
      active: [],
      listShow: false
    }
  },
  computed: {},
  mounted () {
    this.initYears()
    this.initLanguage()
    this.initSubject()
    this.initInstance()
    this.initAuthor()
    this.getInstance()
    points()
  },
  methods: {
    initAll () {
      this.initYears()
      this.initLanguage()
      this.initSubject()
      this.initInstance()
      this.initAuthor()
    },
    // year
    initYears () {
      const params = {
        ...this.queryObj,
        year: ''
      }
      getInstanceYears(params).then(({
        data
      }) => {
        this.dataObj['year'].val = data
      })
    },
    // language
    initLanguage () {
      const params = {
        ...this.queryObj,
        language: ''
      }
      getLanguage(params).then(({
        data
      }) => {
        this.dataObj['language'].val = data
      })
    },
    // subject
    initSubject () {
      const params = {
        ...this.queryObj,
        subject: ''
      }
      getSubject(params).then(({data}) => {
        this.dataObj['subject'].val = data
      })
    },
    // journal
    initInstance () {
      const params = {
        ...this.queryObj,
        journal: ''
      }
      this.dataObj['journal'].val = []
      getInstance(params).then(({
        data
      }) => {
        this.dataObj['journal'].val = data
      })
    },
    // author
    initAuthor () {
      const params = {
        ...this.queryObj,
        author: ''
      }
      this.dataObj['author'].val = []
      getAuthor(params).then(({
        data
      }) => {
        this.dataObj['author'].val = data
      })
    },
    // 获取文献列表
    getInstance () {
      this.listShow = true
      let obj = {
        ...this.queryObj,
        ...this.queryList
      }
      let me = this
      getInstanceList(obj).then((res) => {
        if (res.retCode === 0) {
          me.instanceList = res.data.records
          me.total = parseInt(res.data.total)
          me.listShow = false
        }
      })
    },
    onSearch (query) {
      this.listShow = true
      this.queryList['page'] = 1
      let obj = {
        ...query,
        ...this.queryList
      }
      let me = this
      getInstanceList(obj).then((res) => {
        if (res.retCode === 0) {
          me.instanceList = res.data.records
          me.total = parseInt(res.data.total)
          me.listShow = false
        }
      })
    },
    handleChange () {},
    handleCurrentChange (val) {
      this.queryList['page'] = val
      this.getInstance()
    },
    handleSizeChange (val) {
      this.queryList['pageSize'] = val
      this.getInstance()
    },
    // 跳转详情
    toDetail (item) {
      this.$router.push({
        path: '/instanceDetail',
        query: {
          paperId: item['paperId']
        }
      })
    },
    searchTitle () {
      this.getInstance()
    },
    pushTag (item, i) {
      this.tagList[i] = item['item']
      this.queryList['page'] = 1
      if (i === 0) {
        // year
        this.queryObj['year'] = this.tagList[i]
        this.initAll()
        // this.initLanguage()
        // this.initAuthor()
        // this.initInstance()
        // this.initAuthor()
      } else if (i === 1) {
        // language
        this.queryObj['language'] = this.tagList[i]
        // this.initYears()
        // this.initInstance()
        // this.initAuthor()
        this.initAll()
        this.dataObj['journal'].show = true
        this.dataObj['author'].show = (item.item === 'cn')
      } else if (i === 2) {
        // subject
        this.queryObj['subject'] = this.tagList[i]
        this.initAll()
        // this.initLanguage()
        // this.initYears()
        // this.initInstance()
        // this.initAuthor()
      } else if (i === 3) {
        // journal
        this.queryObj['journal'] = this.tagList[i]
        this.initAll()
        // this.initYears()
        // this.initLanguage()
        // this.initAuthor()
      } else {
        // author
        this.queryObj['author'] = this.tagList[i]
        this.initAll()
        // this.initYears()
        // this.initLanguage()
        // this.initInstance()
      }
      this.getInstance()
      this.$forceUpdate()
    },
    showTag (val, i) {
      if (val === '') {} else {
        this.tagList[i] = val
        if (i === 0) {
          this.initLanguage()
          this.initInstance()
        } else if (i === 1) {
          this.initYears()
          this.initInstance()
        } else {
          this.initYears()
          this.initLanguage()
        }
        this.$forceUpdate()
        this.getInstance()
      }
    },
    resetTag (k, i) {
      this.handleClose(this.queryObj[k], i)
      this.queryObj[k] = ''
    },
    handleClose (tag, t) {
      this.tagList[t] = ''
      if (t === 0) {
        // year
        this.queryObj['year'] = ''
        // this.initLanguage()
        // this.initSubject()
        // this.initInstance()
        // this.initAuthor()
      } else if (t === 1) {
        // language
        this.queryObj['language'] = ''
        this.queryObj['journal'] = ''
        this.queryObj['author'] = ''
        this.tagList[3] = ''
        this.tagList[4] = ''
        this.dataObj['journal'].show = false
        this.dataObj['author'].show = false
        // this.initYears()
        // this.initSubject()
        // this.initInstance()
        // this.initLanguage()
        // this.initAuthor()
      } else if (t === 2) {
        // subject
        this.queryObj['subject'] = ''
        // this.initYears()
        // this.initLanguage()
        // this.initInstance()
        // this.initAuthor()
      } else if (t === 3) {
        // journal
        this.queryObj['journal'] = ''
        // this.initYears()
        // this.initLanguage()
        // this.initAuthor()
      } else {
        // author
        this.queryObj['author'] = ''
        // this.initYears()
        // this.initLanguage()
        // this.initInstance()
      }
      this.initAll()
      this.getInstance()
    },
    getTagDesc (item, i) {
      if (i === 0) {
        return item + '年'
      }
      if (i === 1) {
        return item === 'cn' ? '中文文献' : '英文文献'
      }
      if (i === 2) {
        return item === '1' ? '数据开放' : '授权运营'
      }
      return item
    },
    downloadEndnote () {
      let baseUrl = `${process.env.VUE_APP_DIGI_URL}/api/papers/export`
      let params = '?year=' + this.queryObj['year'] + '&language=' + this.queryObj['language'] + '&journal=' + this.queryObj['journal'] + '&author=' + this.queryObj['author'] + '&page=' + this.queryList['page'] + '&pageSize=' + this.queryList['pageSize']
      axios.get(baseUrl + params).then((res) => {
        if (res.data.retCode === -1) {
          this.$notify.error({
            title: '错误',
            message: '导出失败，请重试！'
          })
        } else {
          this.$notify({
            title: '成功',
            message: '导出endnote成功！',
            type: 'success'
          })
          window.location.href = baseUrl + params
        }
      })
    }
  },
  watch: {}
}
</script>
<style>
    .el-collapse-item__header {
        background: #009844;
        padding-left: 25px;
        font-size: 16px;
        color: white;
        height: 41px;
        border-radius: 4px;
    }

    .el-collapse-item__content {
        line-height: 1.5
    }

    .text__highlight {
        color: #d00000;
        background: none !important;
    }
    /* .el-tag {
  margin-left: 20px;
  margin-bottom: 20px;
} */

    .el-divider--horizontal {
        margin: 0;
    }
</style>
<style scoped>
    .pagination {
        margin: 20px;
    }

    .year_content {
        max-height: 200px;
        overflow-y: auto;
        background: #f5f5f5;
        margin-bottom: 6px;
    }

    .left_item {
        padding-left: 18px;
        cursor: pointer;
    }

    .active_left_item {
        color: #009844;
    }

    .left_item:hover {
        color: #06c;
    }

    .left_item span {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        display: inline-block;
        font-size: 16px;
        font-weight: 400;
    }

    .instance_item {
        margin-top: 10px;
    }

    .instance_item_summary {
        margin-top: 10px;
        line-height: 24px;
        color: #666;
        font-size: 14px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
    }

    .el-select .el-input {
        width: 130px;
    }

    .input-with-select .el-input-group__prepend {
        background-color: #fff;
    }

    .instance_item_title {
        color: #06c;
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 6px;
        cursor: pointer;
    }

    .instance_item_info {
        margin-top: 4px;
        color: #333;
        font-size: 14px;
        line-height: 24px;
    }

    .instance_search {
        margin-top: 52px;
    }

    .instance_search /deep/ input {
        height: 50px;
    }
</style>



// WEBPACK FOOTER //
// src/pages/InstancePage.vue